var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top"}},[_c('Header',{attrs:{"isScrolling":_vm.isScrolling}}),_c('router-view'),_c('GoTop',{attrs:{"isScrolling":_vm.isScrolling}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }